<template>
  <div class="seckill-sketch">
    <div class="title">
      秒杀商品页示意图
      <span v-if="data" class="bangsToggle"> <el-switch v-model="isBangsShow" active-color="#3e6ef7" inactive-color="#f5f5f5" />刘海屏 </span>
    </div>
    <div v-if="data" class="block finalPage">
      <div v-if="isBangsShow" class="bangs" />
      <div class="blockContent relative-position">
        <img :src="data.productImage" alt="" class="img" /><span v-if="displayConfig.isCountdown" class="group-time"> 距离结束X天XX小时 </span>
        
        <div class="group-tip" :style="{ 'background-image': `url(${displayConfig.tagBackPic})` }">
          <span class="group-price-text">{{ displayConfig.tagName }}</span>
          <span class="group-price">
            <span class="font-size-8">￥<span class="font-size-18">{{ data.skuItems[0].price || getMiniValue(data,'price') || "XXX" }}</span>
              <span v-if="data.productOriginPrice > data.skuItems[0].price" class="font-size-10 font-strike r-pl-8">￥{{ data.productOriginPrice || "XXX" }}</span></span>
          </span>
        </div>
      </div>
      <div class="pro-name">
        {{ data.productName }}
        <div class="absolute top-6 right-6 text-grey-15 center font-size-8">
          <i class="iconfont iconzhibohuodongyefenxiang" />
          <br />
          <span>分享</span>
        </div>
      </div>
      <hr style="border: 6px solid #f2f2f2" />
      <div class="pro-info">
        <div class="pro-sku">
          <div class="title">
            选择
          </div>
          <div style="flex-grow: 2">
            &nbsp;&nbsp;请选择 尺寸
          </div>
          <div class="more">
            <i class="iconfont icongengduo" />
          </div>
        </div>
        <div class="pro-sku r-mt-12">
          <div class="title">
            参数
          </div>
          <div style="flex-grow: 2">
            &nbsp;&nbsp;品牌 型号...
          </div>
          <div class="more">
            <i class="iconfont icongengduo" />
          </div>
        </div>
      </div>
      <hr style="border: 6px solid #f2f2f2" />
      <div class="blockContent">
        <img
          v-for="(item, index) in data.productImages" :key="index" :src="item"
          alt="" class="img"
        />
      </div>
      <div class="bottomBar">
        <div class="tools-button">
          <div>
            <i class="iconfont icongouwuchexuanzhong" />
            <p>购物车</p>
          </div>
          <div>
            <i class="iconfont iconlianxidaogou" />
            <p>客服</p>
          </div>
          <div>
            <i class="iconfont icondianzan3" />
            <p>收藏</p>
          </div>
        </div>
        <div class="buy-button">
          {{ buttonName }}
        </div>
      </div>
    </div>
    <div v-else class="default-show" />
  </div>
</template>

<script>
import { toDecimal2 } from '@/util';

export default {
  props: ['data', 'info', 'displayConfig', 'buttonName'],
  data() {
    return {
      isBangsShow: false,
    };
  },
  methods: {
    getMiniValue(item, key) {
      const price = item.skuItems.map((i) => {
        return +i[key];
      });
      return toDecimal2(Math.min.apply(Math, price)) || '';
    },
  }
};
</script>

<style lang="less" scoped>
.seckill-sketch {
  position: relative;
  width: 375px;
  .title {
    display: flex;
    justify-content: space-between;
    margin-right: 6px;
    line-height: 30px;
  }

  .default-show {
    height: 375px;
    background-color: #f5f5f5;
    overflow: hidden;
  }

  .finalPage {
    height: 600px;
    overflow-y: auto;
    > .bangs {
      width: 200px;
      height: 30px;
      background: url(../../../../static/img/phoneHead.png) no-repeat center #060606;
      background-size: 100px;
      border-radius: 0 0 20px 20px;
      position: absolute;
      top: 30px;
      left: calc(50% - 100px);
      z-index: 5;
    }
    .img {
      width: 100%;
    }
    .group-time {
      position: absolute;
      bottom: 17.5%;
      right: 12px;
      font-size: 8px;
      padding: 2px 4px;
      text-align: center;
      width: 120px;
      border-radius: 16px;
      color: #ffffff;
      background-color: #E43834;
    }
    .group-tip {
      background-image: url("https://ssl-picture.tenyun.runsasoft.com/17c653c021ee11edbc6f9f0cd6b88bcb.png");
      background-size: 100% 100%;
      background-position: center;
      height: 64px;
      width: 100%;
      position: relative;
      color: #ffffff;
      .group-price-text {
        position: absolute;
        top: 8px;
        left: 10px;
        font-size: 8px;
        color: #ffffff;
      }
      .group-price {
        position: absolute;
        bottom: 5px;
        left: 10px;
        font-size: 24px;
      }
      .group-num {
        position: absolute;
        top: 10px;
        right: 10px;
        border-radius: 4px;
        color: #ffffff;
      }
    }

    .pro-name {
      position: relative;
      padding: 12px 48px 12px 12px;
      background: #ffffff;
      font-size: 14px;
      color: #000000;
      word-break: break-all;
    }
    .pro-info {
      padding: 12px;
      font-size: 12px;
      .pro-sku {
        display: flex;
        line-height: 30px;
        justify-content: space-between;
        .title,
        .more {
          color: #999999;
          .iconfont {
            font-size: 12px;
          }
        }
      }
    }
    .bottomBar {
      box-shadow: 0 0 24px rgba(0, 0, 0, 0.08);
      padding: 12px;
      display: flex;
      justify-content: space-between;
      margin-top: 12px;
      align-items: center;
      .tools-button {
        line-height: 32px;
        display: flex;
        justify-content: space-between;
        width: 35%;
        color: #999999;
        text-align: center;
        p {
          line-height: 14px;
        }
      }
      .iconfont {
        font-size: 20px;
        color: #999999;
      }
      .buy-button {
        padding: 6px 18px;
        color: #ffffff;
        font-size: 14px;
        background: #ff4444;
        border-radius: 36px;
      }
    }
  }
}
</style>
